import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
    return (
       <div className="page error-bg main-error-wrapper">

			<div className="row align-items-center d-flex flex-row">
				<div className="col-lg-6 pr-lg-4 tx-lg-right">
					<h1 className="display-1 mb-0">404</h1>
				</div>
				<div className="col-lg-6 tx-lg-left">
					<h2>Oops.The Page you are looking  for doesn't  exit..</h2>
					<h6>You may have mistyped the address or the page may have moved.</h6>
					<Link className="btn ripple btn-primary text-center" to="/">Back to Home</Link>
				</div>
			</div>

		</div>
    );
};

export default NotFoundPage;